<template>
  <v-app id="inspire" standalone>
    <v-navigation-drawer app persistent dark v-if="isAuthenticated" v-model="drawer">
      <v-toolbar flat class="teal">
        <v-list-tile-action style="margin-right:15px">
          <v-icon x-large>account_circle</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="white--text">{{ userPayload.role }}</v-list-tile-title>
          <v-list-tile-sub-title class="white--text">{{ userPayload.FullName }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-group
          v-for="section in userMenu"
          :key="section.Title"
          :group="section.Title"
          :prepend-icon="section.Icon"
          no-action="no-action"
        >
          <v-list-tile slot="activator" ripple="ripple" v-on:click="navigate(section.Path)">
            <v-list-tile-content>
              <v-list-tile-title>{{ section.Title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="subItem in section.Pages"
            v-bind:key="subItem.Title"
            v-on:click="navigate(subItem.Path)"
            style="margin-left:-25px"
          >
            <v-list-tile-avatar v-if="subItem.Icon">
              <v-icon>{{ subItem.Icon }}</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.Title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app class="indigo darken-4" dark>
      <v-toolbar-side-icon v-on:click="drawer = !drawer" v-if="isAuthenticated"></v-toolbar-side-icon>
      <v-toolbar-title>Маркет АП</v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="screenWidth > 500">
        <v-btn flat @click.native="logout()" v-if="isAuthenticated">Выйти</v-btn>
      </template>
      <template v-else>
        <v-icon @click.native="logout()" v-if="isAuthenticated" color="white">fa-sign-out</v-icon>
      </template>
    </v-toolbar>

    <v-content>
      <v-container fluid grid-list-md>
        <transition name="slide-fade">
          <router-view v-on:refresh="refresh" />
        </transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { serviceFactory } from "./../apiServices/serviceFactory";
import { menu } from "./../apiServices/menu";
const userService = serviceFactory.get("user");
import router from '../router';

export default {
  name: 'app',
  data() {
    return {
      drawer: true,
      mini: false,
      right: null,
      balance: '-',
      userPayload: userService.getUserPayload(),
    };
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.drawer = false;
      router.push('/login');
    }
    this.refresh()
  },
  watch: {
    userPayload: {
      deep: true,
      handler() {
        this.menu = menu.filter(x => {
          if (x.Access.indexOf(this.userPayload.role.toUpperCase()) > -1) {
            x.Pages = x.Pages.filter(z => z.Access.indexOf(this.userPayload.role.toUpperCase()) > -1)
            return x;
          }
        })
      }
    }
  },
  computed: {
    isAuthenticated() {
      if (this.userPayload == undefined || this.userPayload.exp == undefined)
        return false
      var isExpired = this.userPayload.exp < Math.round(new Date().getTime() / 1000)
      return !isExpired
    },

    screenWidth() {
      return document.documentElement.clientWidth;
    },
    userMenu() {
      return menu.filter(x => {
        if (x.Access.indexOf(this.userPayload.role.toUpperCase()) > -1) {
          x.Pages = x.Pages.filter(z => z.Access.indexOf(this.userPayload.role.toUpperCase()) > -1)
          return x;
        }
      })
    }
  },
  methods: {
    refresh() {
      this.drawer = true
      this.userPayload = userService.getUserPayload()

    },
    logout() {
      this.drawer = false;
      this.balance = '-'
      localStorage.clear()
      router.push('/login');
    },
    navigate(url) {
      if (url != '' && url != undefined) {
        router.push(url);
      }
    }
  },

};
</script>
  <style scope>
.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  display: none;
}

body::-webkit-scrollbar {
  display: none;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.list__tile__action {
  min-width: 36px !important;
}

.list--group .list__tile {
  padding-left: 56px;
}
</style>




// WEBPACK FOOTER //
// App.vue?ccf78c02